import type { TemplateLibraryConfigFieldsFragment, TemplateLibraryConfigInput } from '../../types/graphqlTypes';

/** The current configuration as the update mutation takes it (to change one part and keep the rest). */
export const configInputOf = (config: TemplateLibraryConfigFieldsFragment): TemplateLibraryConfigInput => ({
  hiddenBuiltinIds: config.hiddenBuiltinIds,
  defaultTemplate: config.defaultTemplate ? { source: config.defaultTemplate.source, id: config.defaultTemplate.id } : null,
  brand: {
    address: config.brand.address ?? null,
    phone: config.brand.phone ?? null,
    email: config.brand.email ?? null,
    website: config.brand.website ?? null,
    vat: config.brand.vat ?? null,
  },
});
